import { ListItem, ListItemButton, ListItemText, Typography, useTheme } from '@mui/material';
import { CSSProperties, FC } from 'react';

import { Company } from '@apiContract';

import { sxItemButton } from '../styles';

type ListItemProps = {
  selected: boolean;
  style: CSSProperties;
  item?: Company;
  handleClick: () => void;
};

const Item: FC<ListItemProps> = ({ style, selected, item, handleClick }) => {
  const theme = useTheme();
  if (!item) return null;

  return (
    <ListItem component="div" sx={style} disablePadding>
      <ListItemButton onClick={handleClick} sx={{ ...sxItemButton(selected, theme) }}>
        <ListItemText
          primary={`${item.name} (${item.id})`}
          secondary={
            <Typography
              component="div"
              color="text.secondary"
              variant="caption"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
              overflow="hidden"
            >
              {item.subdomain}
            </Typography>
          }
        />
      </ListItemButton>
    </ListItem>
  );
};

export default Item;
